
let PAY_PAL_CLIENT_ID
if (PRODUCTION) {
  PAY_PAL_CLIENT_ID = 'AX-iP9o8JbFk7yLSVFcn-riP2i_4NyQwUhfgETkJWFhK1uWJjmqNI_rjJaYcjwZOzSviC8h1xzYrPIr8'
} else {
  PAY_PAL_CLIENT_ID = 'ARdTrR6QMAHDubYJbZhw63fbbVeeig6A5x9JOKQ1e2qPKS10ASBGSQRkSajTGlxD-ywkwJbr2pi3WCwc'
}

export {
  PAY_PAL_CLIENT_ID
}
